<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="申请退货" left-arrow fixed
                     @click-left="back"/>
        <van-row style="margin-top: 10px;"></van-row>
        <van-checkbox-group v-model="checked">
            <van-row class="jump-cart-item" type="flex" v-for="(item,index) in list">
                <van-col span="10" class="jump-cart-item-img">
                    <van-checkbox
                            :key="item.goodsId"
                            :name="item.goodsId"
                    ></van-checkbox>
                    <a :href="'#/gooddetail/'+item.goodsId"> <img :src="item.goodsImg"/></a>
                </van-col>
                <van-col span="14" class="jump-cart-item-warp">
                    <a :href="'#/gooddetail/'+item.goodsId"><p class="item-time"></p>
                        <h4>{{item.goodsName}}</h4></a>
                        <p v-if="item.spec&&item.spec!=''">规格：{{item.spec}}
                    <p class="item-price" style="text-align: left">￥{{item.price}}
                    </p>
                </van-col>
            </van-row>
        </van-checkbox-group>
        <p class="c-title">提交申请后请及时与卖家联系，卖家同意退货后可填写退货物流信息</p>
        <div class="c-body">
            <p class="def-color">请选择退货理由</p>
            <van-radio-group v-model="resId">
                <van-row v-for="item in data">
                    <van-radio :name="item.key">{{item.value}}</van-radio>
                </van-row>
            </van-radio-group>
            <p>申请说明</p>
            <van-field v-model="content"
                       type="textarea"
            />
        </div>
        <div class="jump-warphd-foot">
            <van-button size="large" @click="save">提 交</van-button>
        </div>
    </div>
</template>
<script>
    import {
        NavBar,
        Cell,
        CellGroup,
        Field,
        Button,
        Row,
        Col,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Dialog
    } from "vant";

    export default {
        name: "userorderaftersale",
        components: {
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
             [Dialog.name]: Dialog
        },
        data() {
            return {
                checked: [],
                resId: "",
                id: this.$route.query.id,
                content: "",
                orderId: this.$route.query.orderId,
                data: [],
                list: [],
                order: {}
            };
        }, mounted: function () {
            let that = this
            that.$api.post(
                that.jumuc.userCenter.orderReturnApplyCheck,
                {"orderId": that.id},
                successRes => {
                    if(successRes.success){
                          that.data = successRes.data
                    }else{
                         Dialog.alert({
                                    title: "",
                                    message:successRes.msg
                                    }).then(() => {
                                      
                                    });
                    }
                   
                }
            )

            that.$api.get(
                that.jumuc.order.orderDetail,
                {"orderId": that.id},
                successRes => {
                    that.order = successRes.data
                    that.list = that.order.orderInfo.goodsList
                }
            )
        },
        methods: {
            back() {
                history.back();
            }, save() {
                let that = this
                if (that.resId ==''){
                    that.$toast("请选择退货理由")
                    return false;
                }
                /*if (that.resId == '3') {
                    that.resId = ''
                }*/
                if(that.content.trim()==''){
                    that.$toast("请输入申请说明")
                    return false;
                }
                let returnGoodsId=that.checked.join(',');
                that.$api.post(
                    that.jumuc.order.orderReturnApplySave,
                    {"orderId": that.id, "reason": that.resId, "otherStateInfo": that.content,"returnGoodsId":returnGoodsId},
                    successRes => {
                        if (successRes.success) {
                            this.$router.push({
                                path: '/user/order'
                            })
                        } else {
                            that.$toast(successRes.msg)
                        }
                    }
                )
            }
        }
    };
</script>
<style lang="less">
    @bule-thame: #3c6eeb;

    .jump-warphd {
        p {
            font-size: 14px;
            line-height: 28px;
        }
        .c-title {
            padding: 10px 10px;
        }
        .van-radio-group {
            padding: 10px 0;
            font-size: 14px;
            .van-radio {
                padding: 4px 0;
            }
            .van-radio__label {
                color: @bule-thame;
            }
        }
        .c-body {
            padding: 0 10px;
            .van-field {
                border: 1px solid #f7f7f7;
            }
        }
        &-foot {
            border-top: 1px solid #f7f7f7;
            padding: 10px 15px;
            font-size: 14px;
            button {
                background-color: @bule-thame;
                color: white;
                font-weight: 700;
                border-radius: 5px;
                margin: 25px 0 10px;
            }
        }

        .jump-cart {
            &-item {
                background-color: #fff;
                margin-bottom: 15px;
                align-items: center;
                border-radius: 20px;
                padding: 15px;
                position: relative;
                .van-checkbox {
                    height: 100%;
                    line-height: 100%;
                }
                &-img {
                    img {
                        width: 90%;
                    }
                }

                h4 {
                    font-size: 14px;
                    padding: 10px 0;
                }
                &-warp {
                    align-self: flex-start;
                }
                p {
                    font-size: 14px;
                    &.item-time {
                        color: @bule-thame;
                        font-size: 16px;
                        text-align: right;
                    }
                    &.item-price {
                        color: red;
                        font-size: 16px;
                        i {
                            font-size: 18px;
                            float: right;
                            color: #f5a623
                        }
                    }
                }
            }
        }
    }
</style>
